import { addToChainAfter,  ApiHandlerDiscreteParameter, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import {
    chain,
    CallUpdateAccount,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateCurrentAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { account: AccountModel } & HasOnSuccess & HasOnError<string>, 
    UpdateAccountApiParameter,
    AccountModel
>;
export const UpdateSession: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteLoadSession",
        session: {
            ...props.getState().context.session,
            firstName: props.apiResult.firstName,
            lastName: props.apiResult.lastName,
        },
    });
};
addToChainAfter(chain, CallUpdateAccount, UpdateSession);